<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon *ngIf="action === 'edit'" icon="edit-outline"></nb-icon>
        <nb-icon *ngIf="action !== 'edit'" icon="plus-outline"></nb-icon>
        <div *ngIf="action === 'edit'" class="ml-2" i18n>Editing String Source</div>
        <div *ngIf="action === 'create'" class="ml-2" i18n>Creating String Source</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>DRB Item Details</strong>
    <hr />
    <form #xliffForm="ngForm">
      <div class="row">
        <div class="col">
          <label i18n>ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <div class="input-box">
            <span class="prefix" *ngIf="action === 'create'">{{ prefix() }}</span>
            <input
              id="id"
              name="id"
              nbInput
              fullWidth
              style="width: 100%"
              [(ngModel)]="xliff.id"
              #xliffId="ngModel"
              [disabled]="action === 'edit'"
              required
              [pattern]="patternId"
            />
            <span class="sufix" *ngIf="action === 'create'">_dmc</span>
          </div>
          <div *ngIf="xliffId.errors?.pattern">
            <p class="error" i18n>String ID not valid! ID allows only alphanumeric characters and underscore.</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <label i18n>Source<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            id="source"
            name="source"
            nbInput
            fullWidth
            placeholder="Source"
            style="width: 100%"
            [(ngModel)]="xliff.source"
            #source="ngModel"
            [pattern]="patternFirstChar"
            required
          />
          <div *ngIf="source.errors?.pattern">
            <p class="error" i18n>Invalid Source. Value cannot be empty.</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <label i18n>Note<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            id="note"
            name="note"
            nbInput
            fullWidth
            placeholder="Note"
            style="width: 100%"
            [(ngModel)]="xliff.note"
            #note="ngModel"
            [pattern]="patternFirstChar"
            required
            [disabled]="editable"
            value="{{ editable ? 'Do not translate' : xliff.note }}"
          />
          <div *ngIf="note.errors?.pattern">
            <p class="error" i18n>Invalid Note. Value cannot be empty.</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <strong class="text-uppercase col" i18n>Translations</strong>
        <nb-toggle
          class="col"
          style="padding-right: 0; margin-right: 0; text-align: right"
          labelPosition="start"
          status="success"
          [(ngModel)]="editable"
          name="editable"
          nbTooltipPlacement="right"
          nbTooltip="Manually translating the strings will skip the paid translation process."
          i18n-nbTooltip
        >
          <strong class="text-uppercase" i18n>Manual Translation</strong></nb-toggle
        >
      </div>

      <hr />
      <div class="row">
        <dl class="row small" *ngFor="let language of translationLanguages | keyvalue: descOrder">
          <app-string-translation [editable]="editable" [language]="language" [xliff]="xliff"> </app-string-translation>
        </dl>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!xliffForm.form.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
